import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Box } from '@mui/material';
import FinmapleComparator from '../components/Comparator/FinmapleComparator';
import NewsletterSection from '../components/Layout/NewsletterSection';
import TrustStrip from '../components/Layout/TrustStrip';
import SEOHead from '../components/SEO/SEOHead';
import PageHeader from '../components/Layout/PageHeader';
import AtomicAnswer from '../components/SEO/AtomicAnswer';
import FAQSection from '../components/SEO/FAQSection';
import SectionDivider from '../components/Home/SectionDivider';
import EditorialReview from '../components/Layout/EditorialReview';
import CrossLinks from '../components/Layout/CrossLinks';

const schema = {
  '@context': 'https://schema.org',
  '@type': 'FinancialService',
  name: 'Seguros Esenciales para Newcomers - FinMaple',
  description: 'Guía de seguros obligatorios y opcionales para recién llegados a Canadá: salud, renter, auto y vida.',
  provider: { '@type': 'Organization', name: 'FinMaple', url: 'https://www.finmaple.com' },
  dateModified: '2026-02-01',
};

const faqs = [
  {
    question: '¿Necesito seguro de salud privado al llegar a Canadá?',
    answer: 'Depende de la provincia. En Quebec (RAMQ): PR están cubiertos desde el día 1. En Ontario (OHIP): hay 3 meses de espera - NECESITAS seguro privado o una emergencia te puede costar $10,000-100,000+. En BC (MSP): no hay espera.',
  },
  {
    question: '¿Es obligatorio el seguro de inquilino (renter)?',
    answer: 'Legalmente no es obligatorio, pero muchos landlords lo exigen como condición del contrato de arrendamiento. Cuesta solo $15-40/mes y cubre tus pertenencias + responsabilidad civil ($1M+). Es una de las mejores inversiones que puedes hacer.',
  },
  {
    question: '¿Puedo usar mi licencia de conducir de mi país en Canadá?',
    answer: 'Temporalmente sí (3-6 meses según la provincia). Después necesitas licencia canadiense. El seguro de auto es OBLIGATORIO para conducir. Trae tu historial de manejo de tu país - puede reducir el costo del seguro 10-30%.',
  },
  {
    question: '¿Necesito seguro de vida como newcomer?',
    answer: 'Si tienes familia que depende económicamente de ti, sí es recomendable. Term life insurance es la opción más accesible: $20-50/mes por $500K de cobertura. PolicyMe ofrece los precios más bajos 100% online sin necesidad de agente.',
  },
];

const ComparadorSegurosPage = () => {
  const { i18n } = useTranslation();
  return (
  <Box sx={{ bgcolor: '#FFFFFF' }}>
    <SEOHead
      seoKey="insuranceComparator"
      title="Seguros Esenciales para Newcomers en Canadá 2026"
      description="Guía de seguros para recién llegados: salud pública, privado, renter, auto y vida. Qué es obligatorio y qué es opcional."
      canonical="/comparar-seguros"
      routeKey="insuranceComparator"
      schema={schema}
      noIndex={i18n.language !== 'es'}
    />
    <PageHeader
      variant="functional"
      title="Seguros esenciales para newcomers en Canadá - guía 2026"
      subtitle="Qué es obligatorio, qué es opcional y cuánto cuesta cada tipo de seguro."
      breadcrumbs={[{ label: 'Seguros' }]}
      maxWidth="lg"
    />
    <TrustStrip />
    <SectionDivider from="#F7F9FC" to="#FFFFFF" />
    <EditorialReview />
    <Container maxWidth="lg" sx={{ mb: 2 }}>
      <AtomicAnswer text="Al llegar a Canadá, regístrate inmediatamente para el seguro de salud provincial (RAMQ en Quebec, OHIP en Ontario). Si llegas a Ontario, NECESITAS seguro privado para los 3 meses de espera. El seguro de inquilino ($15-40/mes) es casi obligatorio - muchos landlords lo exigen." />
    </Container>
    <Container maxWidth="lg">
      <FinmapleComparator category="insurance" />
    </Container>
    <Container maxWidth="lg">
      <CrossLinks
        links={[
          { label: 'Comparar cuentas bancarias', to: '/comparar-cuentas' },
          { label: 'Calculadora de hipoteca', to: '/calculadora-hipoteca' },
          { label: 'Enviar remesas', to: '/comparar-remesas' },
        ]}
      />
    </Container>
    <Box sx={{ bgcolor: '#F7F9FC', mt: { xs: 4, md: 6 } }}>
      <Container maxWidth="lg" sx={{ py: { xs: 6, md: 8 } }}>
        <FAQSection faqs={faqs} />
      </Container>
    </Box>
    <NewsletterSection />
  </Box>
  );
};

export default ComparadorSegurosPage;
